exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/deep/ .dx-command-edit .dx-link {\n  text-decoration: none;\n  text-align: center;\n  font-size: 16px;\n  margin: 0 3px; }\n\n#dx-data-grid-payorder {\n  height: auto !important; }\n\n/deep/.dx-item .dx-toolbar-item .dx-toolbar-button {\n  margin: 5px; }\n\n/deep/ .dx-datagrid-search-panel.dx-texteditor {\n  margin: 5px; }\n\n/deep/ .dx-freespace-row {\n  display: none !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/src/app/payorder/payorder.component.scss
// module id = ../../../../../src/app/payorder/payorder.component.scss
// module chunks = 0